import FlatButton from 'material-ui/FlatButton'
import MenuItem from 'material-ui/MenuItem'
import SelectField from 'material-ui/SelectField'
import * as R from 'ramda'
import * as React from 'react'
import injectSheet from 'react-jss'
import * as FilteringState from '../../Data/FilteringState'

interface Properties<Filter, FilterType, FilterInput> {
    readonly filterTypeLabel: (filterType: FilterType) => string
    readonly state: FilteringState.M<Filter, FilterType, FilterInput>
    readonly onFilterSelectChanged: (value: FilterType) => void
    readonly onAddFilter: () => void
    readonly onClearFilters: () => void
    readonly filterInputView: (filterInput: FilterInput) => React.ReactNode
}

const styles = {
    root: {
        boxSizing: 'border-box'
    },
    headerH4: {
        fontWeight: 500,
        margin: '0 8px',
    },
    content: {
        padding: '24px',
        width: '544px',
        display: 'flex',
        flexDirection: 'row',
        paddingTop: 0,
    },
    header: {
        padding: '24px 24px 0 24px',
    },
    footer: {
        display: 'flex',
        flexDirection: 'row-reverse',
        borderTop: 'solid 1px $lightgrey',
        padding: '8px 16px',
    },
    select: {
        margin: '0 8px',
    },
}

function filterFormConstructor<Filter, FilterType extends string, FilterInput>() {
    return injectSheet<Properties<Filter, FilterType, FilterInput>>(styles)(
        ({
             classes,
             filterTypeLabel,
             state,
             onFilterSelectChanged,
             onAddFilter,
             onClearFilters,
             filterInputView,
         }) => (
            <div className={classes.root}>
                <div className={classes.header}>
                    <h4 className={classes.headerH4}>Filter</h4>
                </div>
                <div className={classes.content}>
                    <div className={classes.select}>
                        <SelectField
                            floatingLabelText="Kategorie"
                            value={state.selectedFilter}
                            onChange={(event, key, value: FilterType) =>
                                onFilterSelectChanged(value)
                            }
                        >
                            {R.map(
                                filterType =>
                                    <MenuItem
                                        value={filterType}
                                        primaryText={
                                            filterTypeLabel(filterType)
                                        }
                                        key={filterType}
                                    />,
                                state.inactiveFilters,
                            )}
                        </SelectField>
                    </div>
                    {state.addFilterInput !== null &&
                    filterInputView(state.addFilterInput)}
                </div>
                <div className={classes.footer}>
                    <FlatButton
                        primary={true}
                        label="Hinzufügen"
                        onTouchTap={onAddFilter}
                    />
                    <FlatButton
                        label="Filter zurücksetzen"
                        onTouchTap={onClearFilters}
                    />
                </div>
            </div>
        )
    )
}

export const FilterForm = filterFormConstructor()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/Filtering/FilterForm.tsx